import type { TabsProps } from "@mantine/core";
import { Tabs } from "@mantine/core";

export const AvatarStyledTabs = (props: TabsProps) => {
  return (
    <Tabs
      unstyled
      styles={(theme) => {
        return {
          root: {
            position: "relative",
          },
          tab: {
            ...theme.fn.focusStyles(),
            "&:disabled": {
              cursor: "not-allowed",
              opacity: 0.5,
            },
            "&[data-active]": {
              backgroundColor: "#fff",
              color: "#00A5B9",
            },
            alignItems: "center",
            backgroundColor: "#fff",
            color: "#2F2F2F",
            cursor: "pointer",
            display: "flex",
            fontSize: theme.fontSizes.sm,
            position: "relative",
          },
          tabsList: {
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            padding: "4px 0",
            width: "100%",
          },
        };
      }}
      {...props}
    />
  );
};
